import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-plus\"><path d=\"M10.788 7.282V.759H7.281v6.523H.758v3.507H7.28v6.524h3.507v-6.524h6.523V7.282h-6.523Z\" fill=\"#051C2C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol